export default [
    {
        path: '/vehicle-models',
        name: 'vehicle-models',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/VehicleModels.vue')
    }
]